// State Object for ProjectsCatalog. Dont directly mutate it anywhere except the projects/mutations.js file
export const projectsCatalogState = {
  projectsCatalogData: null,
  projectList: null,
  projectDetails: null
};
